import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activePanel: [0,0],
  projectId: null,
  refreshTasksCounter: 0
}

const popupState = createSlice({
  name: 'popupState',
  initialState,
  reducers: {
    setActivePanel: (state, action) => {
      state.activePanel = action.payload
    },
    setProjectId: (state, action) => {
      state.projectId = action.payload
    },
    triggerRefreshTasks: (state) => {
      state.refreshTasksCounter += 1
    }
  }
})

export const { setActivePanel, setProjectId, triggerRefreshTasks, resetActivePanel } = popupState.actions
export default popupState.reducer
